import { AlpineComponent } from 'alpinejs';

interface OtherToggleData {
	isOther: boolean;
	init(): void;
}

/**
 * Reveals a sibling field when a form control's value matches `matchValue`.
 *
 * Trigger detection: the first `[data-other-trigger]` element inside the
 * wrapper, or the first `<select>` as a fallback. Supports `<select>`,
 * `<input type="radio">` (mark each radio in the group), and plain inputs.
 *
 * Toggle the conditional field's `required` via `:required="isOther"`, and
 * its visibility via `x-show="isOther"`.
 */
const otherToggle = (matchValue = 'Other'): AlpineComponent<OtherToggleData> => ({
	isOther: false,

	init() {
		const root = this.$el;
		const trigger =
			root.querySelector<HTMLElement>('[data-other-trigger]') ??
			root.querySelector<HTMLElement>('select');

		if (!trigger) return;

		const readValue = (): string => {
			if (trigger instanceof HTMLInputElement && trigger.type === 'radio') {
				const checked = root.querySelector<HTMLInputElement>(
					`input[type="radio"][name="${CSS.escape(trigger.name)}"]:checked`,
				);
				return checked?.value ?? '';
			}

			if (
				trigger instanceof HTMLInputElement ||
				trigger instanceof HTMLSelectElement ||
				trigger instanceof HTMLTextAreaElement
			) {
				return trigger.value;
			}

			return '';
		};

		const update = () => {
			this.isOther = readValue() === matchValue;
		};

		update();
		root.addEventListener('change', update);
	},
});

export default otherToggle;
